import React, { useEffect, useState } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { Toaster, toast } from 'sonner';
import { apiGet } from '../utils/apiClient';
import { RecipeDetail } from './RecipeDetail';
import { normalizeRecipeDetail } from '../utils/normalizeRecipeDetail';

export function WeeklyRecipeDetailPage() {
  const { weeklyPlanId } = useParams();
  const navigate = useNavigate();
  const [recipe, setRecipe] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    let cancelled = false;
    (async () => {
      try {
        setLoading(true);
        const raw = await apiGet(`/weeklyPlans/${encodeURIComponent(String(weeklyPlanId || ''))}`);
        if (!raw) {
          if (!cancelled) {
            toast.error('Recipe not found');
            navigate('/MealPlan', { replace: true });
          }
          return;
        }
        const normalized = { ...normalizeRecipeDetail(raw), weeklyPlanId: raw._id || raw.id };
        if (!cancelled) {
          setRecipe(normalized);
        }
      } catch (e) {
        console.warn('Failed to load weekly plan recipe for deep link:', e);
        if (!cancelled) {
          toast.error('Unable to load recipe');
          navigate('/MealPlan', { replace: true });
        }
      } finally {
        if (!cancelled) {
          setLoading(false);
        }
      }
    })();
    return () => {
      cancelled = true;
    };
  }, [weeklyPlanId, navigate]);

  const handleBack = () => {
    navigate('/MealPlan');
  };

  const handleTabChange = (tab) => {
    switch (tab) {
      case 'shopping-list':
        navigate('/ShoppingList');
        break;
      case 'recipes':
        navigate('/AllRecipes');
        break;
      case 'more':
        navigate('/More');
        break;
      case 'meal-plan':
      default:
        navigate('/MealPlan');
        break;
    }
  };

  if (loading || !recipe) {
    return (
      <>
        <Toaster position="top-center" />
        <div className="min-h-screen flex items-center justify-center bg-[#F8F7F5]">
          <p className="text-[#757575]">Loading recipe…</p>
        </div>
      </>
    );
  }

  return (
    <>
      <Toaster position="top-center" />
      <RecipeDetail
        recipe={recipe}
        onBack={handleBack}
        activeTab="meal-plan"
        onTabChange={handleTabChange}
        onServesChange={() => {}}
      />
    </>
  );
}

export default WeeklyRecipeDetailPage;
